module.exports = __webpack_public_path__ + "img/wing-on-wo_thumbnail.f0acff52.jpg";